module.exports = __webpack_public_path__ + "img/free_withdrawals.20cd0a6c.svg";